'use strict';

import React from 'react'

import { formatNum } from '@root/utility'

import Link from '@Pure/Link'

const { moment } = window;

export default function PrivateSaleRow ({ data, blank=true, fields, ...props })
{
	moment.locale('fr');

	let row_class = 'c-dashboard__row';

	const link =
	(
		<Link href={ '/gestion-des-ventes-privees/' + data.slug }
			className="u-link-only">
			<span className="u-readers-only">Ouvrir</span>
		</Link>
	);

	return (
		<div className={ row_class }>

			<div className="c-dashboard__cell PrivateSale-date">
				{ moment(data.opening?.date).format('DD/MM/YYYY') }
				{ link }
			</div>

			<div className="c-dashboard__cell PrivateSale-title">

				<div className="c-dashboard__long-text">
					{ data.title }
				</div>

				{ link }

			</div>

			<div className="c-dashboard__cell PrivateSale-action">
				<Link href={ '/gestion-des-ventes-privees/' + data.slug + '/exports' }>
					Voir les exports
				</Link>
			</div>

		</div>
	);
}